export const userHistoryRoute = 'user-history';
export const userHistoryDetailRoute = 'detail';
export const calendarRoute = 'calendar';
export const userHistoryLast = 'last';
export const userHistoryPackageDetail = 'package-detail';
export const exchangeHistory = 'exchange-history';
export const userHistoryReservationCancellation = 'reservation/flight-cancellation';
export const userHistoryHotelReservationCancellation = 'reservation/hotel-cancellation';
export const userHistoryAdditionalServices= 'reservation/additional-services';
export const cancellation = 'flight-cancellation';
export const lastReservation = 'last';
export const orderIdDetail = 'order-detail';
export const userHistoryWithAssistanceDetail = 'with-assistance-detail';
export const userHistoryExtrasWithDetail = 'extras-detail';
export const userHistoryAuth = 'auth';

export const PUSH_DEEPLINK = 'PUSH_DEEPLINK';
